import {
  Component,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';

@Component({
  selector: 'ct-body',
  templateUrl: './ct-body.component.html',
  styleUrls: ['./ct-body.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': "'card-body ' + getStyleClass()",
  }
})
export class CtBodyComponent extends CtrlBaseComponent {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.target);
  }
}